export default __webpack_public_path__ + "static/media/Laughing Powder.b9198b26.png";